// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1mzCt","header":"ReportDetails_header__2jWPR","title":"ReportDetails_title__FHc88","left":"ReportDetails_left__3pW8g"};